/*
 *
 * OperationCustomerInfo
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 04-Dec-2025
 */

import { connect } from 'react-redux'
import OperationCustomerInfo from './OperationCustomerInfo'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  customerInfo: state.operations?.operation?.customerInfo || null,
  isLoading: state.loading.local_OperationDetails || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationCustomerInfo)
